module.exports = __webpack_public_path__ + "static/0041-061af2d9dbc8ab176241fbdb9252cfe9.png";